define(function(require, exports, module) {
    'use strict';

    const serverUtil = require('util/server.util');
    const LoginView = require('../login.view');

    module.exports = LoginView.extend({
        /**
         * Error login action
         * @param  {Object} response
         */
        errorLogin: function(response) {
            const { data } = response || {};
            const content = serverUtil.getErrorMessage(response, { tkPrefix: 'playtech.mobile.system.login.error.' });

            if(this.form.data('userName')) {
                this.form.el.elements.password.focus();
            } else {
                this.form.el.elements.userName.focus();
            }

            if (!data) {
                return;
            }

            if (data.errorCode === 301) {
                this.showSubmitRecaptcha({
                    onError: err => this.form.showErrorMessage(err, data.errorCode)
                });

                return;
            }

            if (data.errorCode === 0) {
                return;
            }

            this.form.showErrorMessage({ content }, data.errorCode);
        }

    });
});
